// PF-6095: a location's own label wins, even when empty; an absent one inherits the chain-wide label.
// Returns undefined when neither is set, so the caller supplies the translated default.
export const resolveReturnButtonText = (
  locationText: string | undefined,
  chainText: string | undefined,
): string | undefined =>
  (locationText !== undefined ? locationText : chainText)?.trim() || undefined;
